import { MenuItem } from "@mui/material";
import { useState } from "react";

import { procurementApi } from "@/main/api";
import AsyncModalConfirmWithLoading from "@/main/components/shared/asyncModalConfirmWithLoading/asyncModalConfirmWithLoading";
import { Controls } from "@/main/services/constants/constantsControl";
import { ProcurementStatusEnum } from "@/main/services/enum/StatusProcurement";
import { getTranslateByKey, isShowControlByElementId } from "@/main/services/utils";

import { useThreeDotsPartClaimContext } from "../context";
import OptionEmptySearchClaim from "../optionEmptySearchClaim";

interface IOptionReopenPartSearchClaimProps {
	guidProcurementSupplierItem: string;
	idStatus: number;
	deliveryBySupplier: boolean;
	cancelationPending: boolean;
	refreshClaim: () => void;
	visualizeRevertCancelation: boolean;
}
function OptionReopenPartSearchClaim({
	guidProcurementSupplierItem,
	idStatus,
	deliveryBySupplier,
	refreshClaim,
	visualizeRevertCancelation,
}: IOptionReopenPartSearchClaimProps) {
	const { generateIdMenu, closeThreeDotsPartClaim } = useThreeDotsPartClaimContext();

	const [isOpenModalReopen, setIsOpenModalReopen] = useState(false);
	const showReopenCancelReturn =
		isShowControlByElementId(Controls.IdReopenPartButton) &&
		deliveryBySupplier &&
		visualizeRevertCancelation &&
		[ProcurementStatusEnum.Cancelled, ProcurementStatusEnum.Returned].includes(idStatus);

	async function reopenCancelReturn() {
		try {
			await procurementApi.reopenPart(guidProcurementSupplierItem);
			refreshClaim();
		} catch {
		} finally {
			setIsOpenModalReopen(false);
		}
	}

	async function handleClickReopenCancelReturn() {
		setIsOpenModalReopen(true);
		closeThreeDotsPartClaim();
	}

	if (!showReopenCancelReturn) return <OptionEmptySearchClaim option="OptionReopenPart" />;
	return (
		<>
			<MenuItem id={generateIdMenu("reopen-part")} onClick={handleClickReopenCancelReturn}>
				{getTranslateByKey("control.reopenPart")}
			</MenuItem>
			<AsyncModalConfirmWithLoading
				id="id-modal-reopen-part"
				isOpen={isOpenModalReopen}
				setIsOpen={setIsOpenModalReopen}
				label={`${getTranslateByKey("information.reopenPart")}?`}
				onConfirm={reopenCancelReturn}
				onCancel={() => setIsOpenModalReopen(false)}
			/>
		</>
	);
}

export default OptionReopenPartSearchClaim;
